// test434
(434 && 0);
